const config = {
  apiUrl: '/masterdataservice', // the API is always served relative to frontend
  publicUrl: process.env.PUBLIC_URL || 'http://localhost:3000',
};
export default config;
